import { render, staticRenderFns } from "./ChooseGood.vue?vue&type=template&id=64b704e6&scoped=true"
import script from "./ChooseGood.vue?vue&type=script&lang=js"
export * from "./ChooseGood.vue?vue&type=script&lang=js"
import style0 from "./ChooseGood.vue?vue&type=style&index=0&id=64b704e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b704e6",
  null
  
)

export default component.exports